import type { TextFieldProps } from "@mui/material";
import { TextField } from "@mui/material";
import classNames from "classnames";
import { forwardRef } from "react";
import styles from "./styles.module.css";

type Props = TextFieldProps & {
  className?: string;
};

export const AppTextField = forwardRef<HTMLInputElement, Props>(
  ({ className, ...rest }, ref) => {
    const clx = classNames(styles["root"], className);

    return (
      <TextField
        ref={ref}
        classes={{
          root: styles["focus"],
        }}
        className={clx}
        {...rest}
      />
    );
  },
);
